import React, { useState, useEffect } from "react";
import axios from "axios";
import DatePick from "./Input/Date";
import Form from "./Input/Form";
import ThoughtCard from "./Input/ThoughtCard";
import { isJsonString } from "./helpers/helpers";

type Thought = {
  label?: string;
  date: string;
  id: string;
  type: string;
  [key: string]: any;
};

function InputView() {
  let date: string;
  let setDate: any;
  const [thoughts, setThoughts] = useState<Thought[]>([]);
  [date, setDate] = useState<string>(new Date().toISOString());
  const [allLabels, setAllLabels] = useState<string[]>([]);

  // Fetch thoughts from the backend
  const fetchThoughts = async () => {
    try {
      const res = await axios.get(
        "https://us-central1-thought-cabinet.cloudfunctions.net/app/getThoughts"
      );
      // sort by date
      res.data.sort((a: Thought, b: Thought) => {
        return new Date(b.date).valueOf() - new Date(a.date).valueOf();
      });
      // iterate and json parse any rich_text
      res.data.forEach((thought: Thought) => {
        // check each key value if json
        for (const key in thought) {
          if (isJsonString(thought[key])) {
            thought[key] = JSON.parse(thought[key]);
          }
        }
      });
      setThoughts(res.data);
      // print sizeof thoughts in bytes
    } catch (error) {
      console.error("Error fetching thoughts:", error);
    }
  };

  // Fetch thoughts when the component mounts
  useEffect(() => {
    fetchThoughts();
    return () => {
      setThoughts([]);
    };
  }, []);

  useEffect(() => {
    const updateLabels = (): void => {
      const collect_labels: string[] = [];
      if (!thoughts) return;
      thoughts.forEach((thought) => {
        // split string by comma
        if (thought.label) {
          const labels = thought.label.split(", ");
          if (labels && labels.length > 0) {
            for (let i = 0; i < labels.length; i++) {
              if (!collect_labels.includes(labels[i])) {
                collect_labels.push(labels[i]);
              }
            }
          }
        }
      });
      setAllLabels(collect_labels);
    };

    updateLabels();
  }, [thoughts]);

  return (
    <div className="row input-view-container">
      <div className="col-3 input-container">
        <h2>Add Input</h2>
        <DatePick onChange={setDate} />
        <Form fetchThoughts={fetchThoughts} date={date} />
      </div>
      <div className="thoughts-container">
        <h2>All Thoughts</h2>
        <div className="thoughts-grid">
          {thoughts?.length &&
            thoughts.map((thought) => (
              <ThoughtCard
                fetchThoughts={fetchThoughts}
                key={thought.id}
                thought={thought}
                allLabels={allLabels}
              />
            ))}
        </div>
      </div>
    </div>
  );
}

export default InputView;
